module.exports = new __parcel__URL__("drumroll-app-home.1a8dd8f8.png").toString();